// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var DOM__HtmlInputElement$SmartcutsMacros = require("./DOM__HtmlInputElement.bs.js");
var Selection__InputSelectionOrCursor$SmartcutsMacros = require("./Selection/Selection__InputSelectionOrCursor.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    return ["SelectionIsUnsupported"];
  } else if (v.TAG === /* Cursor */0) {
    return [
            "Cursor",
            Decco.intToJson(v._0)
          ];
  } else {
    return [
            "Selection",
            Decco.intToJson(v._0),
            Decco.intToJson(v._1)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cursor" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Cursor */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Selection" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Selection */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "SelectionIsUnsupported" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectionIsUnsupported */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromHtmlInputElement(htmlInputElement) {
  if (!DOM__HtmlInputElement$SmartcutsMacros.doesSupportSelection(htmlInputElement)) {
    return /* SelectionIsUnsupported */0;
  }
  var start = htmlInputElement.selectionStart;
  var end_ = htmlInputElement.selectionEnd;
  if (start === end_) {
    return {
            TAG: /* Cursor */0,
            _0: start
          };
  } else {
    return {
            TAG: /* Selection */1,
            _0: start,
            _1: end_
          };
  }
}

function stringify(v) {
  if (typeof v === "number") {
    return "SelectionIsUnsupported";
  } else if (v.TAG === /* Cursor */0) {
    return "Cursor(" + (String(v._0) + ")");
  } else {
    return "Selection(selectionStart=" + (String(v._0) + (", selectionEnd=" + (String(v._1) + ")")));
  }
}

var Cursor = {
  t_encode: t_encode,
  t_decode: t_decode,
  fromHtmlInputElement: fromHtmlInputElement,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "value",
                Decco.stringToJson(v.value)
              ],
              [
                "cursor",
                t_encode(v.cursor)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var cursor = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cursor"), null));
    if (cursor.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                value: value._0,
                cursor: cursor._0
              }
            };
    }
    var e = cursor._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cursor" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function make(htmlInputElement) {
  return {
          value: htmlInputElement.value,
          cursor: fromHtmlInputElement(htmlInputElement)
        };
}

function stringify$1(param) {
  return "{value=" + (param.value + (", cursor=" + (stringify(param.cursor) + "}")));
}

function updateCursorAndValueToMatchHtmlInputElement(htmlInputElement, _input) {
  return {
          value: htmlInputElement.value,
          cursor: fromHtmlInputElement(htmlInputElement)
        };
}

function getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText) {
  var selectionOrCursor = Selection__InputSelectionOrCursor$SmartcutsMacros.ForRecording.fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement);
  var inputValueBeforePaste = htmlInputElement.value;
  var match = htmlInputElement.tagName.toLowerCase();
  var pastedTextWithNewlinesAsSpaces;
  var exit = 0;
  switch (match) {
    case "input" :
        exit = 1;
        break;
    case "textarea" :
        pastedTextWithNewlinesAsSpaces = pastedText;
        break;
    default:
      exit = 1;
  }
  if (exit === 1) {
    pastedTextWithNewlinesAsSpaces = pastedText.replace(/\n/g, " ");
  }
  var cursorPosition = selectionOrCursor.params;
  if (typeof cursorPosition === "number") {
    return inputValueBeforePaste;
  }
  if (cursorPosition.TAG === /* InputSelectionParams */0) {
    var match$1 = cursorPosition._0;
    return StringUtils$SmartcutsMacros.slice(0, match$1.start, inputValueBeforePaste) + (pastedTextWithNewlinesAsSpaces + StringUtils$SmartcutsMacros.slice(match$1.end_, inputValueBeforePaste.length, inputValueBeforePaste));
  }
  var cursorPosition$1 = cursorPosition._0;
  return StringUtils$SmartcutsMacros.slice(0, cursorPosition$1, inputValueBeforePaste) + (pastedTextWithNewlinesAsSpaces + StringUtils$SmartcutsMacros.slice(cursorPosition$1, inputValueBeforePaste.length, inputValueBeforePaste));
}

function makeWithPastedText(domElementIdentifierGenerator, htmlInputElement, pastedText) {
  var inputValueAfterPaste = getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText);
  return {
          value: inputValueAfterPaste,
          cursor: {
            TAG: /* Cursor */0,
            _0: inputValueAfterPaste.length
          }
        };
}

function updateWithPastedText(domElementIdentifierGenerator, htmlInputElement, pastedText, input) {
  var inputValueAfterPaste = getInputValueAfterPaste(domElementIdentifierGenerator, htmlInputElement, pastedText);
  var lastVirtualizedCursorPosition = input.cursor;
  if (typeof lastVirtualizedCursorPosition === "number") {
    return input;
  } else {
    return {
            value: inputValueAfterPaste,
            cursor: {
              TAG: /* Cursor */0,
              _0: lastVirtualizedCursorPosition._0 + pastedText.length | 0
            }
          };
  }
}

exports.Cursor = Cursor;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.make = make;
exports.stringify = stringify$1;
exports.updateCursorAndValueToMatchHtmlInputElement = updateCursorAndValueToMatchHtmlInputElement;
exports.makeWithPastedText = makeWithPastedText;
exports.updateWithPastedText = updateWithPastedText;
/* StringUtils-SmartcutsMacros Not a pure module */
